import React from 'react'
import PropTypes from 'prop-types';
import _ from "underscore";
import util from "../../../../../../../utils/es5Utils";

export default function Charts(props) {
    const { context, childComponents } = props;
    const widgets = util.widgetsOfType(context, 'chart');
    const newProps = { ...props, widgets };
    const childBlocks = _.map(childComponents, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent {...newProps} key={blockKey}/>
    ));

    if (widgets.length > 0 && childBlocks.length > 0) {
        // NOSONAR: `label` is a Blockly toolbox-XML pseudo-element, not a form
        // label, and `text` is a valid Blockly toolbox attribute.
        return [<label key="chart" text="Charts"></label>, ...childBlocks]; // NOSONAR
    }

    return null;
}

Charts.propTypes = {
    context: PropTypes.object.isRequired,
    childComponents: PropTypes.object,
};
